module.exports = __webpack_public_path__ + "img/SWP_Hammer_2H_01 (2).855220b5.png";